import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param manualAssetModel ManualAssetModel
 * @param organisationId String
 * @param blockUI boolean
 * @return {Promise<any>|Promise}
 */
export default (function (manualAssetModel, organisationId, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var obj = {};
    // Als 1 vd velden null is will de api dat het object op null wordt gezet.
    Object.keys(manualAssetModel).forEach(function (key) {
        switch (key) {
            // Check if valid values,
            case 'initialLocation':
                if ((manualAssetModel.initialLocation.latitude == null) ||
                    (manualAssetModel.initialLocation.longitude == null) ||
                    manualAssetModel.initialLocation.timestamp == null) {
                    obj[key] = null;
                }
                else {
                    obj[key] = manualAssetModel[key];
                }
                break;
            case "initialFuelUsedInLiters":
                if (manualAssetModel.initialFuelUsedInLiters.timestamp == null || manualAssetModel.initialFuelUsedInLiters.value == null) {
                    obj[key] = null;
                }
                else {
                    obj[key] = manualAssetModel[key];
                }
                break;
            case 'initialCumulativeOperatingHoursValue':
                if (manualAssetModel.initialCumulativeOperatingHoursValue.timestamp == null || manualAssetModel.initialCumulativeOperatingHoursValue.value == null) {
                    obj[key] = null;
                }
                else {
                    obj[key] = manualAssetModel[key];
                }
                break;
            default:
                obj[key] = manualAssetModel[key];
        }
    });
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_MANUAL_CREATE, { organisationId: organisationId });
    var request = new Request({
        method: Methods.POST,
        url: url,
        data: obj,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
